module.exports = __webpack_public_path__ + "static/img/squad_template_blue.4b8652b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/squad_template_blue.png
// module id = PbqE
// module chunks = 94